var map = {
	"./12/alert.react.svg": 30655,
	"./12/lock.react.svg": 6271,
	"./12/mute.react.svg": 78405,
	"./12/planet.react.svg": 42466,
	"./12/refresh.react.svg": 16647,
	"./16/button.minus.react.svg": 13792,
	"./16/button.plus.react.svg": 78415,
	"./16/catalog-settings-common.svg": 54671,
	"./16/catalog-settings-data-management.svg": 57626,
	"./16/catalog-settings-integration.svg": 48723,
	"./16/catalog-settings-payment.svg": 16003,
	"./16/catalog-settings-restore.svg": 93718,
	"./16/catalog-settings-security.svg": 90621,
	"./16/catalog-settings-storage-management.svg": 34911,
	"./16/mute.react.svg": 23133,
	"./17/cross.react.svg": 19960,
	"./17/plus.svg": 7426,
	"./17/vertical-dots.react.svg": 90196,
	"./20/catalog-settings-common.svg": 92545,
	"./20/catalog-settings-data-management.svg": 68745,
	"./20/catalog-settings-developer.svg": 4376,
	"./20/catalog-settings-gift.svg": 77759,
	"./20/catalog-settings-import.svg": 23463,
	"./20/catalog-settings-integration.svg": 10250,
	"./20/catalog-settings-payment.svg": 72075,
	"./20/catalog-settings-restore.svg": 2960,
	"./20/catalog-settings-security.svg": 74559,
	"./20/catalog-settings-storage-management.svg": 30756,
	"./20/catalog.accounts.react.svg": 49058,
	"./20/catalog.archive.react.svg": 426,
	"./20/catalog.favorites.react.svg": 41620,
	"./20/catalog.folder.react.svg": 50309,
	"./20/catalog.portfolio.react.svg": 49947,
	"./20/catalog.private.react.svg": 53377,
	"./20/catalog.recent.react.svg": 72854,
	"./20/catalog.rooms.react.svg": 52725,
	"./20/catalog.shared.react.svg": 2599,
	"./20/catalog.trash.react.svg": 39197,
	"./20/catalog.user.react.svg": 40806,
	"./24/avi.svg": 27598,
	"./24/csv.svg": 64264,
	"./24/djvu.svg": 66566,
	"./24/doc.svg": 37262,
	"./24/docm.svg": 92760,
	"./24/docx.svg": 8048,
	"./24/docxf.svg": 20775,
	"./24/dotx.svg": 36089,
	"./24/dps.svg": 94999,
	"./24/dpt.svg": 56419,
	"./24/dvd.svg": 13957,
	"./24/epub.svg": 93730,
	"./24/et.svg": 44303,
	"./24/ett.svg": 54118,
	"./24/fb2.svg": 40013,
	"./24/file.svg": 50254,
	"./24/file_archive.svg": 32864,
	"./24/flv.svg": 17572,
	"./24/fodt.svg": 57681,
	"./24/folder.svg": 24256,
	"./24/folder/box.svg": 30350,
	"./24/folder/done.svg": 34822,
	"./24/folder/dropbox.svg": 13313,
	"./24/folder/google.svg": 48031,
	"./24/folder/inProgress.svg": 97206,
	"./24/folder/kdrive.svg": 46609,
	"./24/folder/nextcloud.svg": 97566,
	"./24/folder/onedrive.svg": 28071,
	"./24/folder/owncloud.svg": 78847,
	"./24/folder/sharepoint.svg": 25001,
	"./24/folder/webdav.svg": 17001,
	"./24/folder/yandex.svg": 21647,
	"./24/html.svg": 57547,
	"./24/iaf.svg": 38314,
	"./24/ics.svg": 97857,
	"./24/image.svg": 68248,
	"./24/m2ts.svg": 8280,
	"./24/mht.svg": 84295,
	"./24/mhtml.svg": 92383,
	"./24/mkv.svg": 70274,
	"./24/mov.svg": 54224,
	"./24/mp4.svg": 27333,
	"./24/mpg.svg": 53504,
	"./24/odp.svg": 11543,
	"./24/ods.svg": 99068,
	"./24/odt.svg": 13861,
	"./24/oform.svg": 30123,
	"./24/otp.svg": 55156,
	"./24/ots.svg": 79269,
	"./24/ott.svg": 43831,
	"./24/pdf.svg": 84968,
	"./24/pot.svg": 53068,
	"./24/pps.svg": 23503,
	"./24/ppsx.svg": 6903,
	"./24/ppt.svg": 57720,
	"./24/pptm.svg": 88235,
	"./24/pptx.svg": 60462,
	"./24/rtf.svg": 55435,
	"./24/sound.svg": 32467,
	"./24/stw.svg": 59523,
	"./24/svg.svg": 82102,
	"./24/sxc.svg": 3354,
	"./24/sxi.svg": 84491,
	"./24/sxw.svg": 38179,
	"./24/txt.svg": 52640,
	"./24/webm.svg": 55726,
	"./24/wps.svg": 93299,
	"./24/wpt.svg": 15460,
	"./24/xls.svg": 31130,
	"./24/xlsb.svg": 48541,
	"./24/xlsm.svg": 53578,
	"./24/xlsx.svg": 43897,
	"./24/xml.svg": 41046,
	"./24/xps.svg": 27508,
	"./32/avi.svg": 54897,
	"./32/csv.svg": 56255,
	"./32/djvu.svg": 39647,
	"./32/doc.svg": 2050,
	"./32/docm.svg": 96319,
	"./32/docx.svg": 27678,
	"./32/docxf.svg": 48376,
	"./32/dotx.svg": 83555,
	"./32/dps.svg": 46468,
	"./32/dpt.svg": 17282,
	"./32/dvd.svg": 21537,
	"./32/epub.svg": 5550,
	"./32/et.svg": 3013,
	"./32/ett.svg": 13507,
	"./32/fb2.svg": 57186,
	"./32/file.svg": 6880,
	"./32/file_archive.svg": 52100,
	"./32/flv.svg": 46360,
	"./32/fodt.svg": 88451,
	"./32/folder.svg": 84586,
	"./32/folder/box.svg": 68538,
	"./32/folder/done.svg": 71366,
	"./32/folder/dropbox.svg": 81253,
	"./32/folder/google.svg": 83387,
	"./32/folder/inProgress.svg": 80982,
	"./32/folder/kdrive.svg": 57488,
	"./32/folder/nextcloud.svg": 4162,
	"./32/folder/onedrive.svg": 53855,
	"./32/folder/owncloud.svg": 18674,
	"./32/folder/sharepoint.svg": 81231,
	"./32/folder/webdav.svg": 67431,
	"./32/folder/yandex.svg": 3561,
	"./32/html.svg": 68643,
	"./32/iaf.svg": 5331,
	"./32/ics.svg": 14825,
	"./32/image.svg": 52144,
	"./32/m2ts.svg": 94267,
	"./32/mht.svg": 28527,
	"./32/mhtml.svg": 40281,
	"./32/mkv.svg": 97260,
	"./32/mov.svg": 55904,
	"./32/mp4.svg": 98316,
	"./32/mpg.svg": 38578,
	"./32/odp.svg": 30031,
	"./32/ods.svg": 36655,
	"./32/odt.svg": 9132,
	"./32/oform.svg": 7422,
	"./32/otp.svg": 81724,
	"./32/ots.svg": 41326,
	"./32/ott.svg": 3679,
	"./32/pdf.svg": 33377,
	"./32/pot.svg": 56563,
	"./32/pps.svg": 3631,
	"./32/ppsx.svg": 73912,
	"./32/ppt.svg": 49154,
	"./32/pptm.svg": 63608,
	"./32/pptx.svg": 94296,
	"./32/room/archive.svg": 93843,
	"./32/room/custom.svg": 23813,
	"./32/room/editing.svg": 49145,
	"./32/room/filling.form.svg": 40998,
	"./32/room/form.svg": 5365,
	"./32/room/public.svg": 99564,
	"./32/room/review.svg": 93826,
	"./32/room/view.only.svg": 64107,
	"./32/rtf.svg": 58348,
	"./32/sound.svg": 66681,
	"./32/stw.svg": 70895,
	"./32/svg.svg": 15887,
	"./32/sxc.svg": 77340,
	"./32/sxi.svg": 39868,
	"./32/sxw.svg": 52220,
	"./32/txt.svg": 26031,
	"./32/webm.svg": 15794,
	"./32/wps.svg": 54213,
	"./32/wpt.svg": 18709,
	"./32/xls.svg": 88379,
	"./32/xlsb.svg": 26724,
	"./32/xlsm.svg": 36245,
	"./32/xlsx.svg": 58153,
	"./32/xml.svg": 11747,
	"./32/xps.svg": 34380,
	"./64/avi.svg": 98318,
	"./64/csv.svg": 13611,
	"./64/djvu.svg": 61708,
	"./64/doc.svg": 18767,
	"./64/docm.svg": 35667,
	"./64/docx.svg": 43914,
	"./64/docxf.svg": 57561,
	"./64/dotx.svg": 54524,
	"./64/dps.svg": 68858,
	"./64/dpt.svg": 81558,
	"./64/dvd.svg": 40025,
	"./64/epub.svg": 42737,
	"./64/et.svg": 59642,
	"./64/ett.svg": 51486,
	"./64/fb2.svg": 77463,
	"./64/file.svg": 79247,
	"./64/file_archive.svg": 33285,
	"./64/flv.svg": 82680,
	"./64/fodt.svg": 56240,
	"./64/folder.svg": 31870,
	"./64/folder/box.svg": 59598,
	"./64/folder/done.svg": 28269,
	"./64/folder/dropbox.svg": 72914,
	"./64/folder/google.svg": 79192,
	"./64/folder/inProgress.svg": 47526,
	"./64/folder/kdrive.svg": 87202,
	"./64/folder/nextcloud.svg": 49292,
	"./64/folder/onedrive.svg": 91020,
	"./64/folder/owncloud.svg": 71322,
	"./64/folder/sharepoint.svg": 38602,
	"./64/folder/webdav.svg": 47541,
	"./64/folder/yandex.svg": 26639,
	"./64/html.svg": 62202,
	"./64/iaf.svg": 46908,
	"./64/ics.svg": 99972,
	"./64/image.svg": 96289,
	"./64/m2ts.svg": 51588,
	"./64/mht.svg": 15797,
	"./64/mhtml.svg": 45613,
	"./64/mkv.svg": 26435,
	"./64/mov.svg": 38686,
	"./64/mp4.svg": 60573,
	"./64/mpg.svg": 74666,
	"./64/odp.svg": 94969,
	"./64/ods.svg": 78396,
	"./64/odt.svg": 42607,
	"./64/oform.svg": 61595,
	"./64/otp.svg": 35525,
	"./64/ots.svg": 41892,
	"./64/ott.svg": 2694,
	"./64/pdf.svg": 1144,
	"./64/pot.svg": 88512,
	"./64/pps.svg": 44513,
	"./64/ppsx.svg": 7280,
	"./64/ppt.svg": 67256,
	"./64/pptm.svg": 50399,
	"./64/pptx.svg": 2743,
	"./64/rtf.svg": 87338,
	"./64/sound.svg": 72774,
	"./64/stw.svg": 35555,
	"./64/svg.svg": 70776,
	"./64/sxc.svg": 83494,
	"./64/sxi.svg": 23441,
	"./64/sxw.svg": 21638,
	"./64/txt.svg": 21538,
	"./64/webm.svg": 57586,
	"./64/wps.svg": 57108,
	"./64/wpt.svg": 48701,
	"./64/xls.svg": 3258,
	"./64/xlsb.svg": 32385,
	"./64/xlsm.svg": 11508,
	"./64/xlsx.svg": 34391,
	"./64/xml.svg": 50394,
	"./64/xps.svg": 40398,
	"./96/avi.svg": 40213,
	"./96/csv.svg": 42577,
	"./96/djvu.svg": 99530,
	"./96/doc.svg": 56322,
	"./96/docm.svg": 6985,
	"./96/docx.svg": 46909,
	"./96/docxf.svg": 1114,
	"./96/dotx.svg": 36788,
	"./96/dps.svg": 31254,
	"./96/dpt.svg": 98025,
	"./96/dvd.svg": 11341,
	"./96/epub.svg": 87772,
	"./96/et.svg": 75276,
	"./96/ett.svg": 26887,
	"./96/fb2.svg": 93881,
	"./96/file.svg": 11078,
	"./96/file_archive.svg": 76054,
	"./96/flv.svg": 3428,
	"./96/fodt.svg": 81061,
	"./96/folder.svg": 14748,
	"./96/folder/box.svg": 61145,
	"./96/folder/done.svg": 70559,
	"./96/folder/dropbox.svg": 15119,
	"./96/folder/google.svg": 60835,
	"./96/folder/inProgress.svg": 12728,
	"./96/folder/kdrive.svg": 70096,
	"./96/folder/nextcloud.svg": 31210,
	"./96/folder/onedrive.svg": 72607,
	"./96/folder/owncloud.svg": 94545,
	"./96/folder/sharepoint.svg": 61939,
	"./96/folder/webdav.svg": 12657,
	"./96/folder/yandex.svg": 4086,
	"./96/html.svg": 68319,
	"./96/iaf.svg": 5574,
	"./96/ics.svg": 31723,
	"./96/image.svg": 75358,
	"./96/m2ts.svg": 22528,
	"./96/mht.svg": 58505,
	"./96/mhtml.svg": 69869,
	"./96/mkv.svg": 14602,
	"./96/mov.svg": 88039,
	"./96/mp4.svg": 16867,
	"./96/mpg.svg": 91615,
	"./96/odp.svg": 50233,
	"./96/ods.svg": 82742,
	"./96/odt.svg": 69331,
	"./96/oform.svg": 87333,
	"./96/otp.svg": 76213,
	"./96/ots.svg": 94807,
	"./96/ott.svg": 89335,
	"./96/pdf.svg": 40223,
	"./96/pot.svg": 86949,
	"./96/pps.svg": 60314,
	"./96/ppsx.svg": 20024,
	"./96/ppt.svg": 46852,
	"./96/pptm.svg": 39706,
	"./96/pptx.svg": 77172,
	"./96/rtf.svg": 2905,
	"./96/sound.svg": 37315,
	"./96/stw.svg": 51871,
	"./96/svg.svg": 9995,
	"./96/sxc.svg": 24657,
	"./96/sxi.svg": 96042,
	"./96/sxw.svg": 80276,
	"./96/txt.svg": 24455,
	"./96/webm.svg": 5306,
	"./96/wps.svg": 63308,
	"./96/wpt.svg": 15305,
	"./96/xls.svg": 42456,
	"./96/xlsb.svg": 29202,
	"./96/xlsm.svg": 45645,
	"./96/xlsx.svg": 97892,
	"./96/xml.svg": 96602,
	"./96/xps.svg": 18887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25103;